module.exports = __webpack_public_path__ + "img/decentland.c37a159f.png";